import React from 'react';
import Select from 'react-select';

const ALL_OPTION = { value: 'all', label: 'Select All' };

const MultiSelect = ({ allItems, onChange, selectedItems, title, placeholder }) => {
    const options = [ALL_OPTION, ...allItems];

    const getFormattedValue = (items) => {
        if (!Array.isArray(items)) return [];
        return items.map(item => {
            if (typeof item === 'object' && item !== null && 'value' in item && 'label' in item) {
                return item;
            }
            const foundOption = allItems.find(option => option.value === item);
            return foundOption || { value: item, label: String(item) };
        });
    };

    const currentSelectedValue = getFormattedValue(selectedItems);

    const handleChange = (selected) => {
        if (selected && selected.some(option => option.value === ALL_OPTION.value)) {
            onChange(allItems);
        } else {
            onChange(selected || []);
        }
    };

    const isAllSelected = currentSelectedValue.length === allItems.length && allItems.length > 0;
    const value = isAllSelected ? [ALL_OPTION, ...currentSelectedValue] : currentSelectedValue;

    return (
        <div className="ReportMultiSelect" style={{marginBottom:20}}>
            <div className="reportHeading">
                {/* <h3>{title}</h3> */}
            </div>
            <Select
                options={options}
                isMulti={true}
                onChange={handleChange}
                value={value}
                placeholder={placeholder || `Search ${title}`}
                styles={{
                    valueContainer: (provided) => ({
                        ...provided,
                        maxHeight: '300px',
                        overflowY: 'auto',
                    }),
                }}
            />
        </div>
    );
};

export default MultiSelect;
